export default "__VITE_PUBLIC_ASSET__885c5c5b__"